 import fileDownload from "js-file-download";
import { message } from 'antd';

import axios from 'util/axiosConfig';

export const getAllHL7SentMessages = async (params) => {
    let modifiedParams = {
        ...params,
        page: params.page - 1
    }
    return await axios.post(`/api/v1/get-sent-hl7-message`, modifiedParams)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const searchHL7SentMessages = async (params) => {
    let modifiedParams = {
        ...params,
        page: params.page - 1
    }
    return await axios.post(`/api/v1/get-sent-hl7-message`, modifiedParams)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const getHL7OutMessage = async (id) => {
    return await axios.get(`/api/v1/download-hl7-sent-message`, {
        params: {
            id
        }
    })
        .then(function (response) {
            if (response.status === 200) {
                const fileName = id + '.hl7';
                 fileDownload(response.data, fileName);
            } else {
                message.error('Failed to download file!');
            }
        })
        .catch(function (error) {
            message.error('Failed to download file!');
        });
}

export const resendHL7SentMessageAPI = async (id) => {
    return await axios.get(`/api/v1/resend-hl7-sent-message`, {
        params: {
            id
        }
    })
        .then(function (response) {
            if (response.status === 200) {
                return response.data;
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}